import ajax from './index'
import apiEnv from './apiEnv'
// 客户新增
export function customerAdd(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/add`, data)
}
// 客户信息
export function customerInfoUpdate(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/comp/update`, data)
}
// 客户信息修改
export function customerDetail(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/detail`, data)
}
// 商务信息修改
export function busInfoUpdate(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/update`, data)
}
// 商务信息
export function busInfo(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/busInfo`, data)
}
// 联系人列表
export function linkmanList(data) {
    return ajax.post(`${apiEnv.api2}/crm/linkman/page`, data)
}
// 新增联系人
export function linkmanAdd(data) {
    return ajax.post(`${apiEnv.api2}/crm/linkman/add`, data)
}
// 修改联系人
export function linkmanUpdate(data) {
    return ajax.post(`${apiEnv.api2}/crm/linkman/update`, data)
}
// 商机列表
export function opportunityList(data) {
    return ajax.post(`${apiEnv.api2}/crm/business/page`, data)
}
//商机-新增|修改
export function opportunityUpdate(data) {
    return ajax.post(`${apiEnv.api2}/crm/business/addOrModi`, data)
}
// 工单信息
export function orderSummar(data) {
    return ajax.post(`${apiEnv.api2}/crm/workOrder/summar`, data)
}
// 合同列表
export function contracts(data) {
    return ajax.post(`${apiEnv.api2}/crm/contract/cust/page`, data)
}
// 跟进记录
export function custFollowAdd(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/custFollow/add`, data)
}
// 写跟进
export function custFollow(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/custFollow/page`, data)
}
//获取pdf地址
export function ConvertPDF(data) {
    // return ajax.post(`${apiEnv.api1}/api/BpoContract/ConvertPDF`, data);
    return ajax.post(`${apiEnv.api4}/api/BpoContract/ConvertPDF`, data);

}
//关联母公司
export function parentCompany(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/parentCompany/page`, data);
}
// 保存选中的母公司(点击dialog确定的时候)
export function parentCompanyUpdate(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/parentCompany/update`, data);
}

//大客户信息
export function GetBigCustomerConfig(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountJobConfig/GetBigCustomerConfig`, data);
}
//编辑大客户信息
export function AddBigCustomerConfig(data) {
    return ajax.post(`${apiEnv.api1}/api/Admin/AccountJobConfig/AddBigCustomerConfig`, data);
}

// 公海客户列表
export function seasList(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/seas/page`, data)
}
// 公海客户类型
export function seasTypeList(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/seas`, data)
}
// 公司信息查询-阿里云
export function aliyunCompanyInfo(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/aliyun/company/info`, data)
}
// 企业是否存在
export function companyExist(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/company/exist`, data)
}
// 获取当前省份尝试id
export function areaInfoGet(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/areaInfo/get`, data)
}
// 负责人 （1=销售负责人，2=外部销售负责人，3=对接负责人，4=客户成功部负责人）
export function optionHeaders(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/headers`, data)
}
// 新增公海客户
export function seasAdd(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/add`, data)
}
// 领域
export function prodDomains(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/prodDomains`, data)
}
// 我的客户列表角标
export function myCustCount(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/myCust/count`, data)
}
// 我的客户列表
export function myCustList(data) {
    return ajax.post(`${apiEnv.api2}/crm/cust/myCust/page`, data)
}
// 我的客户客户类型
export function myCustType(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/custType`, data)
}

// 商机列表
export function businessList(data) {
    return ajax.post(`${apiEnv.api2}/crm/business/page`, data)
}
// 项目类型（服务类型）
export function optionServiceStage(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/serviceStage`, data)
}
// 商机 新增|修改
export function addBusinessOrModi(data) {
    return ajax.post(`${apiEnv.api2}/crm/business/addOrModi`, data)
}
// 商机 基本信息
export function basicDetails(data) {
    return ajax.post(`${apiEnv.api2}/crm/business/details`, data)
}
// 商机 对应客户
export function corCustList(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/corCust`, data)
}
// 删除 商机列表某项
export function businessDel(data) {
    return ajax.post(`${apiEnv.api2}/crm/business/del`, data)
}
// 商机 商机进度编辑
export function progModi(data) {
    return ajax.post(`${apiEnv.api2}/crm/business/progModi`, data)
}
// 销售数据 销售负责人
export function salesDataHeaders(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/salesDataHeaders`, data)
}
// 销售数据 统计
export function statisticalData(data) {
    return ajax.post(`${apiEnv.api2}/crm/salesData/stat`, data)
}
// 写跟进
export function addFollowUpOrModi(data) {
    return ajax.post(`${apiEnv.api2}/crm/traceRecord/addOrModi`, data)
}
// 跟进列表
export function followUpList(data) {
    return ajax.post(`${apiEnv.api2}/crm/traceRecord/page`, data)
}

// 用户企业列表
export function getCompanyList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/com/getCompanyList`, data)
}
// 大客户|用户企业详情
// 进入大客户配置 enterpriseVipInfo enterConfiguration
export function enterpriseVipInfo(data) {
    return ajax.post(`${apiEnv.api2}/vipCustomers/enterConfiguration`, data)
}
// 保存配置
export function enterpriseVipInfoEdit(data) {
    return ajax.post(`${apiEnv.api2}/vipCustomers/enterpriseVipInfoEdit`, data)
}
// 大客户-价格配置--保存服务定价价格编辑
export function enterpriseVipPriceEdit(data) {
    // return ajax.post(`${apiEnv.api2}/vipCustomers/enterpriseVipPriceEdit`, data)
    return ajax.post(`${apiEnv.api2}/vipCustomers/enterpriseVipPriceEditPro`, data)
}
// 大客户-价格配置--价格查看
export function enterpriseVipPriceQuiry(data) {
    return ajax.post(`${apiEnv.api2}/vipCustomers/enterpriseVipPriceQuiry`, data)
}
// 价格配置-一级产品定价列表
export function primaryProductPricingSettings(data) {
    return ajax.post(`${apiEnv.api2}/vipCustomers/primaryProductPricingSettings`, data)
}
// 大客户-价格配置-查看服务定价列表
export function servicePricePagAll(data) {
    return ajax.post(`${apiEnv.api2}/vipCustomers/servicePricePagAll`, data)
}
// 大客户-更新一级产品价格折扣
export function updateVipPrimaryPriceConf(data) {
    return ajax.post(`${apiEnv.api2}/vipCustomers/updateVipPrimaryPriceConf`, data)
}